function BlogPosts() {
  const blocks = document.querySelectorAll('[data-blog-posts]');

  if (!blocks.length || typeof site === 'undefined') {
    return;
  }

  blocks.forEach((block) => {
    const filters = block.querySelectorAll('.blog-posts__filter');
    const results = block.querySelector('[data-blog-posts-results]');
    const searchInput = block.querySelector('[data-blog-posts-search]');
    const searchReset = block.querySelector('[data-blog-posts-search-reset]');

    if (!results) {
      return;
    }

    const allowedCategories = block.dataset.categoryIds
      ? block.dataset.categoryIds.split(',').filter(Boolean)
      : [];
    let searchTimer = null;
    let requestId = 0;

    const getActiveCategoryId = () => {
      const activeFilter = block.querySelector('.blog-posts__filter.is-active');

      return activeFilter ? activeFilter.dataset.categoryId || '0' : '0';
    };

    const setActiveCategory = (categoryId) => {
      filters.forEach((item) => {
        const isActive = (item.dataset.categoryId || '0') === categoryId;

        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    const setResetVisibility = () => {
      if (!searchReset || !searchInput) {
        return;
      }

      searchReset.classList.toggle('is-visible', searchInput.value.trim() !== '');
    };

    const fetchPosts = (categoryId = getActiveCategoryId()) => {
      const currentRequestId = requestId + 1;
      requestId = currentRequestId;
      results.classList.add('is-loading');

      const formData = new FormData();
      formData.append('action', 'codelibry_filter_blog_posts');
      formData.append('nonce', site.ajax_nonce);
      formData.append('category_id', categoryId);
      formData.append('post_type', block.dataset.postType || 'post');
      formData.append('search', searchInput ? searchInput.value.trim() : '');
      formData.append('featured_button_text', block.dataset.featuredButtonText || 'Read More');
      formData.append('card_button_text', block.dataset.cardButtonText || 'Read More');

      allowedCategories.forEach((allowedCategory) => {
        formData.append('allowed_categories[]', allowedCategory);
      });

      fetch(site.ajax_url, {
        method: 'POST',
        credentials: 'same-origin',
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          if (requestId !== currentRequestId) {
            return;
          }

          if (response.success && response.data.html) {
            results.innerHTML = response.data.html;
            document.dispatchEvent(new CustomEvent('codelibry:reveal-refresh'));
          }
        })
        .finally(() => {
          if (requestId === currentRequestId) {
            results.classList.remove('is-loading');
          }
        });
    };

    setResetVisibility();

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        const categoryId = filter.dataset.categoryId || '0';

        if (filter.classList.contains('is-active') || results.classList.contains('is-loading')) {
          return;
        }

        setActiveCategory(categoryId);
        fetchPosts(categoryId);
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        setResetVisibility();

        searchTimer = window.setTimeout(() => {
          fetchPosts();
        }, 1000);
      });
    }

    if (searchReset && searchInput) {
      searchReset.addEventListener('click', () => {
        window.clearTimeout(searchTimer);
        searchInput.value = '';
        setResetVisibility();
        setActiveCategory('0');
        fetchPosts('0');
        searchInput.focus();
      });
    }
  });
}

export default BlogPosts;
